import React from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import LABEL from '../../../business-const/Label/Label'

import {
    SvgIconSeguroVida,
} from '../../../business-components/SvgIcon/SvgIconGarantiasAtuais/SvgIconGarantiasAtuais'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    StepperPadrao
} from '../../../business-components/Stepper/Stepper'

import {
    calculaIdadesDataSimulacao,
} from '../cliente-form/ClienteService'

import {
    calculaTotaisSeguroVidaCotacao,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoService'

import {
    calculaTotaisSeguroVida,
} from '../seguroVida-form/SeguroVidaService'

import SeguroVidaCotacaoForm from '../seguroVidaCotacao-form/SeguroVidaCotacaoForm'

import SeguroVidaPropostaForm from '../seguroVidaProposta-form/SeguroVidaPropostaForm'

import SeguroVidaForm from '../seguroVida-form/SeguroVidaForm'



const AcompanhamentoFormSeguroVida = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, vars,
    popupCotacao, popupApolice, arquivoList }) => {
        
    const stepsSvgIcon = [
        SvgIconSeguroVida,
        SvgIconSeguroVida,
        SvgIconSeguroVida,
    ]

    const steps = [
        LABEL.cotacao,
        LABEL.proposta,
        LABEL.apolice,
    ]

    const stepsTitle2 = [
        '',
        '',
        '',
    ]

    const stepsContent = [
        <SeguroVidaCotacaoForm
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            popupCotacao={popupCotacao}
        />,
        <SeguroVidaPropostaForm
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            arquivoList={arquivoList}
        />,
        <SeguroVidaForm
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            vars={vars}
            popupApolice={popupApolice}
            arquivoList={arquivoList}
        />,
    ]
    
    const valuesStepsTitle = [
        '',
        '',
        LABEL.morteQualquerCausa,
    ]

    const valuesStepsTitle2 = [
        '',
        '',
        LABEL.valorPremioTotal,
    ]

    if (values.stepAcompanhamentoSeguroVida.activeStep === 0) {

        calculaTotaisSeguroVidaCotacao(values)
    }

    if (values.stepAcompanhamentoSeguroVida.activeStep === 1) {

        //
    }

    if (values.stepAcompanhamentoSeguroVida.activeStep === 2) {

        calculaTotaisSeguroVida(values)
    }

    useSingleton(async () => {

        calculaIdadesDataSimulacao(values, false)

        if (values.stepAcompanhamentoSeguroVida.activeStep !== 0) {

            calculaTotaisSeguroVidaCotacao(values)
        }

        if (values.stepAcompanhamentoSeguroVida.activeStep !== 1) {

            //
        }

        if (values.stepAcompanhamentoSeguroVida.activeStep !== 2) {

            calculaTotaisSeguroVida(values)
        }
    })

    return (
        <ValidatorFormPadrao 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            {popupCotacao
                ?
                    <SeguroVidaCotacaoForm
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        popupCotacao={popupCotacao}
                    />
                :
                    popupApolice
                        ?
                            <SeguroVidaForm
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                vars={vars}
                                popupApolice={popupApolice}
                                arquivoList={arquivoList}
                            />
                        :
                            <StepperPadrao
                                stepsType={"cardValor"}
                                stepsSvgIcon={stepsSvgIcon}
                                steps={steps}
                                stepsTitle2={stepsTitle2}
                                stepsContent={stepsContent}
                                valuesStep={values.stepAcompanhamentoSeguroVida}
                                valuesStepsTitle={valuesStepsTitle}
                                valuesStepsValor={values.stepsValorAcompanhamentoSeguroVida}
                                valuesStepsTitle2={valuesStepsTitle2}
                                valuesStepsValor2={values.stepsValor2AcompanhamentoSeguroVida}
                                naoPermiteConcluir={true}
                            />
            }
        </ValidatorFormPadrao>
    )
}

export default AcompanhamentoFormSeguroVida